import urlMixin from '@/mixins/urlMixin';

export default {
  mixins: [urlMixin],
  props: {
    sortBy: {
      type: String,
      default: '',
    },
    sortDesc: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    const propsData = this.$options.propsData || {};
    const hasSortByProp = Object.prototype.hasOwnProperty.call(propsData, 'sortBy');
    const hasSortDescProp = Object.prototype.hasOwnProperty.call(propsData, 'sortDesc');
    const routeSortBy = this.$route?.query?.sortBy;
    const routeSortDesc = this.$route?.query?.sortDesc;
    const parsedRouteSortDesc = routeSortDesc === undefined ? undefined : routeSortDesc === 'true' || routeSortDesc === true;

    return {
      sorting: {
        sortBy: hasSortByProp ? this.sortBy : (routeSortBy !== undefined ? routeSortBy : this.sortBy),
        sortDesc: hasSortDescProp ? this.sortDesc : (parsedRouteSortDesc !== undefined ? parsedRouteSortDesc : this.sortDesc),
      },
    };
  },
  watch: {
    'sorting.sortBy': function (newSortBy) {
      if (this.appendToQuery && newSortBy !== undefined && this.$route.query.sortBy !== newSortBy) {
        this.appendToQueryParams('sortBy', newSortBy);
      }
    },
    'sorting.sortDesc': function (newSortDesc) {
      if (
        this.appendToQuery
        && newSortDesc !== undefined
        && String(this.$route.query.sortDesc) !== String(newSortDesc)
      ) {
        this.appendToQueryParams('sortDesc', newSortDesc);
      }
    },
  },
};
